import { render, staticRenderFns } from "./EditBlockAndPrivacy.vue?vue&type=template&id=2ebc56b6&"
import script from "./EditBlockAndPrivacy.vue?vue&type=script&lang=js&"
export * from "./EditBlockAndPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports